(() => {
  if (window.__ssConversionFixes) return;
  window.__ssConversionFixes = true;

  function normaliseCompareLinks(root = document) {
    root.querySelectorAll('a[href*="/collections/diffusers"]').forEach((a) => {
      const href = a.getAttribute('href') || '';
      if (href.includes('compare') || href.includes('#compare')) a.setAttribute('href', '/pages/comparatif-diffuseurs');
    });
  }

  function normaliseReviewCopy(root = document) {
    root.querySelectorAll('.revs__verified').forEach((el) => {
      if (/v[ée]rifi/i.test(el.textContent || '')) el.textContent = 'Avis client';
    });
    root.querySelectorAll('h1,h2,h3').forEach((heading) => {
      const text = (heading.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === 'Adopté dans plus de 5 000 intérieurs' || text === 'Adopté par nos +5 000 clients satisfaits') {
        heading.textContent = 'Ils racontent leur expérience avec Secret Scenta';
      }
    });
  }

  function fixDarcyPresentation(root = document) {
    const pdp = root.querySelector?.('.pdp--journey') || document.querySelector('.pdp--journey');
    if (!pdp) return;
    const title = pdp.querySelector('.pdp__title')?.textContent?.trim().toLowerCase() || '';
    if (!title.includes('darcy')) return;

    document.body.classList.add('ss-darcy-pdp');
    pdp.querySelectorAll('.pdp__options legend').forEach((legend) => {
      if (/\bCOLOR\b/i.test(legend.textContent || '')) legend.innerHTML = legend.innerHTML.replace(/\bCOLOR\b/i, 'COULEUR');
    });

    /* The first gallery frame is now rendered server-side from the selected variant.
       No synthetic change event here: it caused an unnecessary second image request on load. */
  }

  function forceSinglePairFormats(root = document) {
    root.querySelectorAll('[data-bundle][data-single-pair="true"] [data-step="scent"] select[data-format]').forEach((select) => {
      const option = [...select.options].find((o) => /^100\s*ml$/i.test(o.textContent.trim()) && !o.disabled);
      if (!option) return;
      if (select.value !== option.value) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      select.closest('.bundle__format')?.classList.add('ss-fixed-100ml');
    });
  }

  function tidyHomepage() {
    if (document.body.dataset.template !== 'index') return;

    document.querySelectorAll('.category-row, .category, section').forEach((section) => {
      section.querySelectorAll('*').forEach((el) => {
        if (el.children.length === 0 && el.textContent.trim() === 'Darcy · Titanium · Platinum') el.textContent = 'Darcy · Titanium';
      });
    });

    if (document.querySelector('[data-bundle]')) {
      [...document.querySelectorAll('h1,h2,h3')].forEach((heading) => {
        if (heading.textContent.trim() === 'Votre diffuseur et votre parfum, avec 20 € de remise') {
          const wrapper = heading.closest('.shopify-section') || heading.closest('section');
          if (wrapper) wrapper.remove();
        }
      });
    }

    const reviews = document.getElementById('customer-reviews');
    const reviewsWrapper = reviews?.closest('.shopify-section') || reviews;
    const trust = document.querySelector('.trust')?.closest('.shopify-section');
    if (reviewsWrapper && trust && trust.nextElementSibling !== reviewsWrapper) trust.after(reviewsWrapper);
  }

  function init(root = document) {
    normaliseCompareLinks(root);
    normaliseReviewCopy(root);
    fixDarcyPresentation(root);
    forceSinglePairFormats(root);
    tidyHomepage();
  }

  // Multiple fragrances are intentionally allowed.
  // The real automatic discount is limited to one discounted fragrance per order;
  // additional fragrances remain at their normal price.

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target || document));
})();
